module.exports = __webpack_public_path__ + "img/bd(3).80213101.png";